import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';

import initMenu from './components/menu';
import initHeader from './components/header';
import initTickers from './components/tickers';
import initCookies from './components/cookies';

import initHeaderAnim from './components/header-anim';
import initHomeHero from './components/home-hero';
import initHomeWork from './components/home-work';
import initOverlay from './components/overlay';
import initFooter from './components/footer';

import initProjectSlider from './components/project-slider';
import initCounters from './components/counters';

import initContact from './components/contact';

initCookies();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menuEl = document.querySelector('.js-menu');

if (menuEl) {
    initMenu(menuEl);
}

const header = document.querySelector('.js-header');

if (header) {
    initHeader(header);
}

const tickers = document.querySelectorAll('.js-ticker');

if (tickers && tickers.length > 0) {
    initTickers(tickers);
}

const headerAnim = document.querySelector('.js-header-anim');

if (headerAnim) {
    initHeaderAnim(headerAnim);
}
const footerReveal = document.querySelector('.js-footer-reveal');

if (footerReveal) {
    initFooter(footerReveal);
}

const homeHero = document.querySelector('.js-home-hero');

if (homeHero) {
    initHomeHero(homeHero);
}

const homeWork = document.querySelector('.js-home-work');

if (homeWork) {
    initHomeWork(homeWork);
}

const overlayTriggers = document.querySelectorAll('.js-overlay-trigger');

if (overlayTriggers && overlayTriggers.length > 0) {
    initOverlay(overlayTriggers);
}

const projectSliders = document.querySelectorAll('.js-project-slider');

if (projectSliders && projectSliders.length > 0) {
    initProjectSlider(projectSliders);
}

const counters = document.querySelectorAll('.js-counter');

if (counters && counters.length > 0) {
    initCounters(counters);
}

const contact = document.querySelector('.js-contact');

if (contact) {
    initContact(contact);
}
